import React, { FunctionComponent, useEffect } from 'react'
import EmailInput from './emailInput'
import classNames from 'classnames'
import { TextField } from '@mui/material'
// import { useMobiApi } from '@/services/mobi-api'
import useIntl from '@/utils/intl'
import { Obj } from '..'
import ChoosePackage from './choosePackage'
import ChooseSim from './chooseSim'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'

import { useMobiApi } from '@/services/mobi-api'
import Loader from '@/components/ui/loader'
import { useToast } from '@/context/ToastContext'
import { TouristPackage } from '@/services/mobi-api/tourist/types'
import { moneyFormatter } from '@/utils/helpers'

// import DarkButton from '@/components/ui/Buttons/SecondaryButton'

interface Props {
  onClick: (objs: Obj) => void
}

const buyTouristSim: FunctionComponent<Props> = ({ onClick }) => {
  const [currentStep, setCurrentStep] = React.useState(0)
  const { translate } = useIntl()
  const [objs, setObj] = React.useState<Obj | undefined>()
  const [loading, setLoading] = React.useState<boolean>(true)
  const [packages, setPackages] = React.useState<TouristPackage | undefined>(undefined)
  const { tourist } = useMobiApi()
  const { showError } = useToast()

  useEffect(() => {
    const url = new URL(window.location.href)
    const promo = url.searchParams.get('promo')
    void getCurrentPackage(promo ?? '')
  }, [])

  const handleNext = (obj: Obj): void => {
    const mergedObj = {
      ...objs,
      ...obj
    }
    setObj(mergedObj)
    if (currentStep === 2) {
      onClick(mergedObj ?? {})
    } else {
      setCurrentStep(currentStep + 1)
      scrollToNextSection()
    }
  }
  const getCurrentPackage = async (promo?: string): Promise<void> => {
    try {
      const res = await tourist.getPackage(promo ?? undefined)
      setPackages(res)
      if (res?.categories[0]?.subCategories[0]?.packages[0]?.basePrice !== undefined && res?.categories[0]?.subCategories[0]?.packages[0]?.basePrice < 1 && currentStep === 0) {
        handleNext({ choosenPackage: res?.categories[0].subCategories[0].packages[0] })
      }
      setLoading(false)
    } catch (e) {
      showError(translate('tourist.request.failed'))
    }
  }

  const handleBack = (): void => {
    setCurrentStep(currentStep - 1)
  }

  const ConfirmedEmail: FunctionComponent = () => {
    return (
      <div className='p-4 bg-surfaceInverse rounded-xl'>
        <TextField
          label={translate('tourist.email')}
          variant='outlined'
          className='w-full rounded-lg'
          value={objs?.email}
          disabled
          sx={{
            '& fieldset': {
              borderRadius: '12px',
              borderColor: '#D6D6D6'
            },
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: '#D6D6D6'
              }
            },
            '& label.Mui-focused': {
              color: '#262626'
            },
            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
            {
              display: 'none'
            },
            '& input[type=number]': {
              MozAppearance: 'textfield'
            }
          }}
        />
      </div>
    )
  }
  interface PrevStepProps {
    title: string
    value: string
    index: number
  }
  const prevStep = (props: PrevStepProps): JSX.Element => {
    return (
      <div className='flex justify-between bg-surfaceInverse rounded-xl p-4 '>
        <div className='flex flex-col gap-2'>
          <span className='text-[#6E7882] text-xs'>{props.title}</span>
          <span className='text-[#6E7882] text-sm font-bold'>{props.value ?? ''}</span>
        </div>
        {objs?.choosenPackage?.basePrice !== undefined && objs?.choosenPackage?.basePrice < 1 && props.index === 0 ? <></> : <DarkButton type='outlined' size='sm' onClick={() => handleChangeStep(props.index)}>{translate('tourist.change')}</DarkButton>}
      </div>
    )
  }

  const handleChangeStep = (step: number): void => {
    setCurrentStep(step)
  }
  const steps = [
    {
      label: translate('tourist.choosePackage'),
      body: <ChoosePackage next={handleNext} back={handleBack} dataPackage={packages ?? undefined} />,
      past: prevStep({ title: translate('tourist.single.package'), value: ((objs?.choosenPackage) != null) ? `${objs.choosenPackage.duration !== undefined ? `${objs.choosenPackage.duration} ${objs.choosenPackage.duration > 1 ? translate('tourist.days') : translate('tourist.day')} - ` : ' '} ${objs.choosenPackage.name} / ${objs.choosenPackage.basePrice !== undefined && objs.choosenPackage.basePrice > 0 ? (`${moneyFormatter(objs.choosenPackage.basePrice)}`) : 'FREE'}` : '', index: 0 }),
      id: 'package'
    },
    {
      label: translate('tourist.choose'),
      body: <ChooseSim next={handleNext} back={handleBack} instanceId={objs?.instanceId ?? ''} />,
      past: prevStep({ title: translate('tourist.choosen'), value: objs?.choosenSim === 'SELFSIM' ? translate('tourist.self') : translate('tourist.esim') ?? '', index: 1 }),
      id: 'sim'
    },
    {
      label: translate('tourist.email.register'),
      body: <EmailInput objs={objs ?? undefined} next={handleNext} back={handleBack} />,
      past: <ConfirmedEmail />,
      id: 'email'
    }
  ]

  const scrollToNextSection = (): void => {
    const sectionElement = document.getElementById(steps[currentStep].id)
    const nextSectionElement = document.getElementById(
      steps[currentStep + 1].id
    )
    if (sectionElement != null && nextSectionElement != null) {
      sectionElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      })
    }
  }

  return (
    <div className='flex flex-col justify-center w-full h-full p-3 lg:w-3/4 md:w-4/5 sm:w-4/5 md:p-0'>
      {loading !== undefined && !loading
        ? (

            steps.map((step, index) => (
              <div
                key={index}
                id={step.id}
                className='flex flex-col gap-4 my-4 transition-all duration-500'
              >
                <span
                  className={classNames(
                    currentStep !== index
                      ? 'text-[#6E7882] font-bold'
                      : 'font-extrabold text-textHigh'
                  )}
                >
                  {index + 1}. {step.label}
                </span>
                {currentStep > index
                  ? <div>{step.past}</div>
                  : (
                    <div
                      className={classNames(
                        currentStep < index ? 'opacity-50 pointer-events-none' : ''
                      )}
                    >
                      {step.body}
                    </div>
                    )}
              </div>
            )))
        : (
          <div className='flex items-center justify-center w-full h-[50vh]'>
            <Loader />
          </div>
          )}

    </div>
  )
}

export default buyTouristSim
